const formatLargeNumber = (num: number, decimalCount: number = 1): string => {
  if (num < 1000) {
    return num.toString()
  } else if (num < 1000000) {
    let kValue = (num / 1000).toFixed(decimalCount)
    kValue = decimalCount === 0 ? kValue.split('.')[0] : kValue
    return `${kValue}k`
  } else {
    let mValue = (num / 1000000).toFixed(decimalCount)
    mValue = decimalCount === 0 ? mValue.split('.')[0] : mValue
    return `${mValue}m`
  }
}

const formatLargeNumberWithCommas = (num: number): string => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const formatMsToMinutes = (milliseconds: number) => {
  const seconds = Math.floor((milliseconds / 1000) % 60)
  const minutes = Math.floor((milliseconds / 1000 / 60) % 60)

  return [minutes.toString().padStart(2, '0'), seconds.toString().padStart(2, '0')].join(':')
}

const formatCentsToDollars = (cents: number) =>
  (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  })

export const Numbers = {
  formatLargeNumber,
  formatLargeNumberWithCommas,
  formatMsToMinutes,
  formatCentsToDollars
}
